module.exports = __webpack_public_path__ + "static/medical-1600x697-b07a3c4127307de3effda3231fcc40b1.png";